import { TAddon, TDuration, TPlanSummary } from 'common/cms-types'
import { AddonSlug, PlanSlug } from 'common/planSlugs'

export type AddonPriceItem = {
  id: string
  quantity?: number
}

export const getPriceIds = (
  plans: TPlanSummary[],
  addons: TAddon[] | null,
  currentPlan: string | null,
  currentAddons: string[],
  duration: TDuration,
  additionalPlans?: PlanSlug[],
  directorsCount?: number,
) => {
  if (!currentPlan) {
    return { addons: [] as AddonPriceItem[], additionalPlans: [], product_id: '' }
  }
  const selectedPlan = plans.find((v) => v.slug === currentPlan)
  const selectedAddons = addons?.filter((v) => currentAddons.includes(v.slug))
  const selectedAdditionalPlans = additionalPlans
    ? plans.filter((p) => additionalPlans.includes(p.slug as PlanSlug))
    : []

  if (selectedPlan) {
    let addonItems: AddonPriceItem[] =
      selectedAddons?.map((v) => ({
        id: duration === 'month'
          ? v.pricing.month_price_id
          : v.pricing.year_price_id,
      })) || []

    // When per-director pricing is active, add DSA with quantity
    // DSA is not in value.addons (currentAddons), so look it up from the full addons list
    if (typeof directorsCount === 'number' && directorsCount > 0) {
      const dsaAddon = addons?.find(
        (v) => v.slug === AddonSlug.DIRECTORS_SERVICE_ADDRESS,
      )
      if (dsaAddon) {
        const dsaPriceId =
          duration === 'month'
            ? dsaAddon.pricing.month_price_id
            : dsaAddon.pricing.year_price_id

        addonItems.push({ id: dsaPriceId, quantity: directorsCount })
      }
    }

    return {
      addons: addonItems.filter((item) => !!item.id),
      additionalPlans: selectedAdditionalPlans.map((v) =>
        duration === 'month'
          ? v.pricing.month_price_id
          : v.pricing.year_price_id,
      ),
      product_id:
        duration === 'month'
          ? selectedPlan.pricing.month_price_id
          : selectedPlan.pricing.year_price_id,
    }
  } else {
    console.error('Could not find selected plan', currentPlan, plans)
  }
}
